<template>

  <div>
     <b-modal
      ref="add-flexible-combo-modal"
      hide-footer
      :title="modalTitle"
      size="xl"
      >
      <div class="combo-condition-note mb-2">
        <span class="combo-condition-note__label">Điều kiện áp dụng:</span>
        <span class="combo-condition-note__value">{{ conditionApplyDescription }}</span>
      </div>
      <b-table
        :items="listItem"
        :fields="fields"
        bordered
        hover
        v-if="renderComponent"
        > <template v-slot:cell(name)="row"
          >
          <div @click="onChangeProduct(row.item)">
             <vue-autosuggest
              v-model="row.item.name"
              :suggestions="filteredOptions"
              :should-render-suggestions="
                (totalResults, loading) =>
                  shouldRenderAutosuggest(row, totalResults, loading)
              "
              @selected="onSelected"
              :limit="10"
              @input="onInputChange"
              :input-props="{
                class: 'autosuggest__input',
                placeholder: 'Nhập sản phẩm',
                style: 'border-radius:0px!important',
              }"
              >
              <template slot="before-suggestions">
                <div
                  v-if="showAutosuggestEmptyState(row)"
                  class="autosuggest__empty-message"
                >
                  Không có kết quả phù hợp
                </div>
              </template>
              <div
                slot-scope="{ suggestion }"
                style="display: flex; align-items: center"
              >

                <div>
                   <span class="text-primary"
                    >({{ convertPrice(suggestion.item.listedPrice) }}) (</span
                  > <span
                    v-if="suggestion.item.quantityInStock > 0"
                    class="text-success"
                    >Tồn CTB: {{ suggestion.item.quantityInStock }}</span
                  > <span
                    v-else
                    class="text-danger"
                    >Tồn CTB: {{ suggestion.item.quantityInStock }}</span
                  > ) {{ suggestion.item.name }}
                </div>

              </div>
               </vue-autosuggest
            >
          </div>
           </template
        > <template slot="bottom-row"
          >
          <td
            v-bind:colspan="2"
            class="text-right font-weight-bolder"
            style="font-weight: 600; color: #181c32"
          >
             <span>Tổng</span>
          </td>

          <td class="text-right font-weight-bolder">
             <span>{{ convertPrice(sumQuantity) }}</span
            >
          </td>

          <td class="text-right font-weight-bolder">
             <span>{{ convertPrice(sumProductPrice) }}</span
            >
          </td>

          <td class="text-right font-weight-bolder">
             <span>{{ convertPrice(sumDiscountAmount) }}</span
            >
          </td>

          <td class="text-right font-weight-bolder">
             <span>{{ convertPrice(sumTotalAmount) }}</span
            >
          </td>

          <td></td>
           </template
        > </b-table
      > <b-button
        style="font-weight: 600; width: 100px"
        variant="primary"
        size="sm"
        @click="onSave"
        >Lưu</b-button
      > <b-button
        style="margin-left: 10px; font-weight: 600; width: 70px"
        variant="secondary"
        size="sm"
        @click="hideModal"
        >Hủy</b-button
      > </b-modal
    >
  </div>

</template>

<style>
  .table th,
.table td {
  padding: 0.75rem;
  vertical-align: middle;
  border-top: 1px solid #ecf0f3;
}
.table.b-table.table-sm > thead > tr > [aria-sort]:not(.b-table-sort-icon-left),
.table.b-table.table-sm
  > tfoot
  > tr
  > [aria-sort]:not(.b-table-sort-icon-left) {
  background-position: right calc(1.5rem / 2) center;
  padding-right: calc(0.3rem + 0.65em);
}

.autosuggest__results {
  position: absolute;
  width: 100%;
  max-height: 200px;
  z-index: 999;
  border: 1px solid #e0e0e0;
  overflow-y: scroll;
  overflow-x: hidden;
  background-color: #fff;
}

.autosuggest__results-container {
  position: relative;
  width: 100%;
}

.autosuggest__input {
  display: block;
  width: 100%;
  height: calc(1.35em + 1.1rem + 2px);
  line-height: 1.35;
  padding: 0.55rem 0.75rem;
  font-weight: 400;
  font-size: 0.925rem;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.28rem;
  transition:
    border-color 0.15s ease-in-out,
    box-shadow 0.15s ease-in-out;
}

.autosuggest__input:focus {
  outline: none !important;
  border: 1px solid #92c5f9;
}

.autosuggest__results-item:hover {
  background-color: #ddd;
}

.autosuggest__results ul li {
  padding: 8px;
}

.autosuggest__empty-message {
  padding: 10px 12px;
  text-align: center;
  color: #7e8299;
  font-size: 0.925rem;
  border-bottom: 1px solid #ebedf3;
  background: #fafbfc;
}

.combo-condition-note {
  border: 1px solid #d6ebff;
  background: #f5faff;
  padding: 8px 12px;
  border-radius: 4px;
  font-size: 13px;
  color: #3f4254;
}

.combo-condition-note__label {
  font-weight: 600;
  margin-right: 4px;
}
#autosuggest {
  width: 100%;
}
</style>

<script>
  import { makeToastFaile, convertPrice } from '@/utils/common'
  import ApiService from '@/core/services/api.service'
  import { TIME_OUT, TIME_TRIGGER } from '@/utils/constants'
  import decounce from 'debounce'
  import { sumBy } from 'lodash'
  import { AMOUNT_TYPE, PRODUCT_TYPE, BILL_ITEM_TYPE } from '@/utils/enum'

  export default {
    props: ['flexibleComboItem', 'storeId'],
    data() {
      return {
        listItem: [],
        fields: [
          {
            key: 'count',
            label: 'STT',
            sortable: false,
            thStyle: { fontWeight: 600, color: '#181c32', width: '5%' },
            tdClass: 'text-center',
          },
          {
            key: 'name',
            label: 'Tên',
            sortable: false,
            thStyle: { fontWeight: 600, color: '#181c32', width: '35%' },
            tdClass: 'text-left',
          },
          {
            key: 'quantity',
            label: 'SL',
            sortable: false,
            thStyle: { fontWeight: 600, color: '#181c32', width: '5%' },
            tdClass: 'text-right',
          },
          {
            key: 'productPrice',
            label: 'Giá niêm yết',
            sortable: false,
            thStyle: { fontWeight: 600, color: '#181c32', width: '10%' },
            tdClass: 'text-right',
            formatter: (value) => {
              return convertPrice(value)
            },
          },
          {
            key: 'discountAmount',
            label: 'Chiết khấu',
            sortable: false,
            thStyle: { fontWeight: 600, color: '#181c32', width: '10%' },
            tdClass: 'text-right',
            formatter: (value) => {
              return convertPrice(value)
            },
          },
          {
            key: 'totalAmount',
            label: 'Tổng tiền',
            sortable: false,
            thStyle: { fontWeight: 600, color: '#181c32', width: '10%' },
            tdClass: 'text-right',
            formatter: (value) => {
              return convertPrice(value)
            },
          },
          {
            key: 'description',
            label: 'Mô tả',
            sortable: false,
            thStyle: { fontWeight: 600, color: '#181c32', width: '20%' },
            tdClass: 'text-left',
          },
        ],
        filteredOptions: [
          {
            data: [],
          },
        ],
        optionsProduct: [],
        renderComponent: true,
        currentIndex: 0,
        sumQuantity: 0,
        sumDiscountAmount: 0,
        sumTotalAmount: 0,
        sumProductPrice: 0,
        productLoading: false,
        PRODUCT_TYPE: PRODUCT_TYPE,
        BILL_ITEM_TYPE: BILL_ITEM_TYPE,
      }
    },
    computed: {
      modalTitle() {
        return `Thêm sản phẩm cho combo: ${this.flexibleComboItem.name}`
      },
      conditionApplyDescription() {
        const applyProducts = this.flexibleComboItem.applyProducts || []
        const applyCategories = this.flexibleComboItem.applyCategories || []

        if (applyProducts.length > 0) {
          const names = applyProducts.map((x) => x.name).filter((x) => !!x)
          const preview = names.slice(0, 3).join(', ')
          const remain = names.length - 3
          if (preview) {
            return `Theo sản phẩm: ${preview}${remain > 0 ? ` và ${remain} sản phẩm khác` : ''}`
          }
          return `Theo sản phẩm (${applyProducts.length} sản phẩm)`
        }

        if (applyCategories.length > 0) {
          const names = applyCategories.map((x) => x.name).filter((x) => !!x)
          const preview = names.slice(0, 3).join(', ')
          const remain = names.length - 3
          if (preview) {
            return `Theo danh mục: ${preview}${remain > 0 ? ` và ${remain} danh mục khác` : ''}`
          }
          return `Theo danh mục (${applyCategories.length} danh mục)`
        }

        return 'Không giới hạn'
      },
      numProChoose: {
        cache: false,
        get() {
          return this.listItem.filter((item) => item.productId).length
        },
      },
    },
    mounted() {},
    methods: {
      forceRerender() {
        this.renderComponent = false

        this.$nextTick(() => {
          this.renderComponent = true
        })
      },
      showModal: function () {
        this.listItem = []
        this.getInfoById()
        this.$refs['add-flexible-combo-modal'].show()
      },
      hideModal() {
        this.$refs['add-flexible-combo-modal'].hide()
      },
      convertPrice,
      /**
       * Cần ít nhất 1 dòng khớp rổ điều kiện:
       * - Nếu applyProducts không rỗng → chỉ kiểm tra productId / parentProductId với applyProducts.
       * - Chỉ khi applyProducts rỗng → mới kiểm tra productCategory với applyCategories.
       */
      hasAtLeastOneItemInConditionBasket() {
        const fc = this.flexibleComboItem || {}
        const applyProducts = fc.applyProducts || []
        const applyCategories = fc.applyCategories || []
        if (applyProducts.length === 0 && applyCategories.length === 0) {
          return true
        }

        if (applyProducts.length > 0) {
          const productIdSet = new Set(applyProducts.map((p) => String(p.id)))
          return this.listItem.some((row) => {
            if (!row.productId) return false
            const pid = String(row.productId)
            const ppid =
              row.parentProductId != null && row.parentProductId !== ''
                ? String(row.parentProductId)
                : null
            return productIdSet.has(pid) || (ppid != null && productIdSet.has(ppid))
          })
        }

        const categoryIdSet = new Set(applyCategories.map((c) => String(c.id)))
        return this.listItem.some((row) => {
          if (!row.productId) return false
          const pcat =
            row.productCategory != null && row.productCategory !== ''
              ? String(row.productCategory)
              : null
          return pcat != null && categoryIdSet.has(pcat)
        })
      },
      onSave() {
        const childroductIds = this.listItem.map((item) => item.productId)
        if (childroductIds.includes(null)) {
          return makeToastFaile('Vui lòng chọn sản phẩm cho bộ combo!')
        }
        if (!this.hasAtLeastOneItemInConditionBasket()) {
          const hasApplyProducts = (this.flexibleComboItem.applyProducts || []).length > 0
          return makeToastFaile(
            hasApplyProducts
              ? 'Vui lòng chọn ít nhất 1 sản phẩm nằm trong danh sách sản phẩm áp dụng của combo.'
              : 'Vui lòng chọn ít nhất 1 sản phẩm thuộc danh mục được áp dụng trong combo.',
          )
        }
        const listProductInCombo = this.listItem.map((item) => {
          return {
            productName: item.name,
            productNameVat: '',
            productCode: item.productCode || '',
            imeiCode: '',
            productId: item.productId,
            sellingPrice: item.productPrice,
            quantity: item.quantity,
            discount: 0,
            quantityInStock: item.quantityInStock,
            flexibleComboItemId: item.id,
            discountAmount: item.discountAmount,
            totalAmount: item.totalAmount,
          }
        })
        const mainLineProductId = listProductInCombo.find(
          (c) => c.productId != null && c.productId !== '',
        )?.productId
        const result = {
          productName: this.flexibleComboItem.name,
          flexibleComboName: this.flexibleComboItem.name,
          productNameVat: '',
          productCode: this.flexibleComboItem.code,
          flexibleComboCode: this.flexibleComboItem.code,
          imeiCode: '',
          productId: mainLineProductId ?? this.flexibleComboItem.id,
          sellingPrice: this.sumTotalAmount,
          sellingPriceMask: this.sumTotalAmount,
          quantity: 1,
          discountAmount: 0,
          discountType: AMOUNT_TYPE.MONEY,
          note: '',
          discountProgramId: null,
          productType: PRODUCT_TYPE.PRODUCT_COMBO,
          itemType: BILL_ITEM_TYPE.PRODUCT,
          listedPrice: 0,
          checked: true,
          isGetVat: false,
          comboItems: listProductInCombo,
          flexibleComboId: this.flexibleComboItem.id,
          billItemId: this.flexibleComboItem.billItemId,
        }
        if (!this.flexibleComboItem.billItemId) {
          this.$emit('addComboChild', result)
        } else {
          this.$emit('editComboChild', result)
        }
        this.hideModal()
      },
      getInfoById() {
        this.listItem = this.flexibleComboItem.listItem.map((item, index) => {
          return {
            ...item,
            count: index + 1,
            discountAmount: 0,
            totalAmount: 0,
            name: '',
          }
        })

        const items = this.flexibleComboItem.listItem
        this.listItem.forEach((element) => {
          const item = items.find((x) => x.flexibleComboItemId === element.id)
          element.productId = item ? item.productId : null
          element.name = item ? item.productName : ''
          element.discountAmount = item ? item.discountAmount : 0
          element.productPrice = item ? item.listedPrice : 0
          element.totalAmount = item ? item.totalAmount : 0
        })
      },
      onChangeProduct(selectedItem) {
        this.currentIndex = this.listItem.findIndex((item) => item.id == selectedItem.id)
        this.optionsProduct = []
        this.filteredOptions = [
          {
            data: [],
          },
        ]
      },
      onInputChange(text) {
        if (!text) {
          text = ''
        }
        const searchText = text.toString().trim()
        if (!text) {
          this.listItem[this.currentIndex].productId = null
        }
        this.debounceInput(searchText)
      },
      shouldRenderAutosuggest(row, _totalResults, loading) {
        if (row.index !== this.currentIndex) return false
        const query = (row.item.name || '').toString().trim()
        if (!query) return false
        if (this.productLoading) return false
        if (loading) return false
        return true
      },
      showAutosuggestEmptyState(row) {
        if (row.index !== this.currentIndex) return false
        const query = (row.item.name || '').toString().trim()
        if (!query || this.productLoading) return false
        const data = this.filteredOptions && this.filteredOptions[0] && this.filteredOptions[0].data
        return !data || data.length === 0
      },
      debounceInput: decounce(function (textSearch) {
        this.fetchProduct(textSearch)
      }, TIME_TRIGGER),
      onSelected(option) {
        if (option.item.quantityInStock < this.listItem[this.currentIndex].quantity) {
          this.listItem[this.currentIndex].name = ''
          makeToastFaile('Số lượng tồn kho sản phẩm không đủ!')
          return
        }
        let discountAmount = (option.item.discountRate * option.item.listedPrice) / 100
        if (option.item.discountType === AMOUNT_TYPE.MONEY) {
          discountAmount = option.item.discountRate
        }
        this.listItem[this.currentIndex].productId = option.item.productId
        this.listItem[this.currentIndex].productCode = option.item.productCode || ''
        this.listItem[this.currentIndex].productBarCode = option.item.barCode || option.item.productBarCode || ''
        this.listItem[this.currentIndex].name = option.item.name
        this.listItem[this.currentIndex].productPrice = option.item.listedPrice
        this.listItem[this.currentIndex].discountAmount = this.roundMoney(discountAmount)
        const totalAmount =
          option.item.listedPrice * this.listItem[this.currentIndex].quantity -
          this.roundMoney(discountAmount)
        this.listItem[this.currentIndex].totalAmount = totalAmount
        this.listItem[this.currentIndex].quantityInStock = option.item.quantityInStock
        this.listItem[this.currentIndex].parentProductId = option.item.parentProductId
        this.listItem[this.currentIndex].productCategory = option.item.productCategory
        this.calComboValue()
      },
      fetchProduct(textSearch) {
        if (!textSearch) {
          this.optionsProduct = []
          this.filteredOptions = [
            {
              data: [],
            },
          ]
          return
        }
        const item = this.listItem[this.currentIndex]
        const params = {
          textSearch: textSearch,
          storeId: this.storeId,
          referenceType: item.type,
          referenceId: item.referenceId,
          flexibleComboId: this.flexibleComboItem.id,
        }
        this.optionsProduct = []
        this.filteredOptions = [
          {
            data: this.optionsProduct,
          },
        ]
        this.productLoading = true
        ApiService.query(
          'v1/flexible-combo/search-product',
          { params },
          { timeout: TIME_OUT },
        ).then((response) => {
          const dataset = response.data.data || []
          this.optionsProduct = dataset.map((element) => {
            return {
              productId: element.productId,
              name: element.productName,
              productCode: element.productCode,
              parentProductId: element.parentProductId || null,
              productCategory: element.productCategory || null,
              productNameVat: '',
              sellingPrice: element.sellingPrice,
              returnSellingPrice: 0,
              productType: element.productType,
              imeiCode: '',
              listAccessoryBonus: [],
              listAccessoryPromotion: [],
              quantityInStock: element.quantityInStock,
              listedPrice: element.listedPrice,
              discountRate: item.discountRate,
              discountType: item.discountType,
            }
          })
          this.filteredOptions = [
            {
              data: this.optionsProduct,
            },
          ]
          this.productLoading = false
        }).catch(() => {
          this.productLoading = false
          this.optionsProduct = []
          this.filteredOptions = [
            {
              data: [],
            },
          ]
        })
      },
      calComboValue() {
        this.sumQuantity = sumBy(this.listItem, 'quantity')
        this.sumProductPrice = sumBy(this.listItem, 'productPrice')
        this.sumDiscountAmount = sumBy(this.listItem, 'discountAmount')
        this.sumTotalAmount = sumBy(this.listItem, 'totalAmount')
      },
      roundMoney(value) {
        const tmpValue = Math.floor(value / 1000)
        return tmpValue * 1000
      },
    },
  }
</script>

